global.Buffer = global.Buffer || require('buffer').Buffer;

import React, {useEffect, useState} from 'react';
import {Dimensions} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import RenderHtml, {defaultSystemFonts} from 'react-native-render-html';
import {useTheme} from 'styled-components';

import {useNavigation, useRoute} from '@react-navigation/native';

import {
  Container,
  Content,
  ContentHeader,
  Footer,
  Header,
  HeaderContent,
  IconContainer,
  InfoText,
  Logo,
  ContentScroll,
  Section,
  SectionHeader,
  SectionTitle,
  Title,
  SectionContent,
} from './styles';
import {Header as HeaderButton} from '../../../components/Interface/Headers/Header';

import {ParceiroDTO} from '../../../dtos/ParceiroDTO';
import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {apiMasterClin} from '../../../services/api';
import {Loading} from '../../../components/Interface/Loadings/Loading';
import {RFValue} from 'react-native-responsive-fontsize';

interface Params {
  data: ParceiroDTO;
}

export function Store() {
  const navigation = useNavigation();
  const theme = useTheme();
  const route = useRoute();

  const [parceiro, setParceiro] = useState<ParceiroDTO>({} as ParceiroDTO);
  const [haveUnits, setHaveUnits] = useState<boolean | null>(
    null as boolean | null,
  );

  const systemFonts = [...defaultSystemFonts, theme.fonts.regular];

  const {data} = route.params as Params;

  useEffect(() => {
    let isMounted = true;

    async function fetchUnits() {
      await apiMasterClin
        .get('/parceiro/' + data.id + '/unidades')
        .then(({data}) => {
          const {unidades} = data;

          if (unidades && unidades.length > 0) {
            if (isMounted) {
              setHaveUnits(true);
              isMounted = false;
            }
          } else {
            if (isMounted) {
              setHaveUnits(false);
              isMounted = false;
            }
          }
        });
    }

    async function fetchParceiro() {
      await apiMasterClin.get('/parceiro/' + data.id).then(({data}) => {
        if (isMounted) {
          setParceiro(data);
          fetchUnits();
        }
      });
    }

    fetchParceiro();

    return () => {
      isMounted = false;
    };
  }, []);

  return parceiro.id && haveUnits !== null ? (
    <Container>
      <Header>
        <HeaderContent source={{uri: data.imagens.bg_hotsite}}>
          <HeaderButton
            icon="chevron-left"
            action={() => navigation.goBack()}
            statusBarColor={theme.colors.primary}
            statusBarLight
          />
        </HeaderContent>
      </Header>
      <Content>
        <ContentHeader>
          <IconContainer
            style={{
              backgroundColor: '#fff',
              shadowColor: theme.colors.text_dark,
              shadowOffset: {width: 0, height: 7},
              shadowOpacity: 0.2,
              shadowRadius: 6,
              elevation: 8,
            }}>
            <Logo source={{uri: parceiro.imagens.logo}} resizeMode="contain" />
          </IconContainer>
          <InfoText>{parceiro.categoria.nome}</InfoText>
          <Title>{parceiro.nome}</Title>
        </ContentHeader>
        <ContentScroll
          showsVerticalScrollIndicator={false}
          contentContainerStyle={{paddingBottom: RFValue(20)}}>
          <Section>
            <SectionHeader>
              <SectionTitle>Benefício</SectionTitle>
            </SectionHeader>

            <SectionContent>
              <RenderHtml
                contentWidth={Dimensions.get('window').width - 48}
                source={{html: `<div>${parceiro.beneficio}</div>`}}
                systemFonts={systemFonts}
                tagsStyles={{
                  div: {
                    fontFamily: theme.fonts.regular,
                    color: theme.colors.title,
                  },
                }}
              />
            </SectionContent>
          </Section>
          <Section
            style={{marginBottom: 0, paddingBottom: 0, borderBottomWidth: 0}}>
            <SectionHeader>
              <SectionTitle>Como utilizar?</SectionTitle>
            </SectionHeader>

            <SectionContent>
              <RenderHtml
                contentWidth={Dimensions.get('window').width - 48}
                source={{html: `<div>${parceiro.beneficio_utilizacao}</div>`}}
                systemFonts={systemFonts}
                tagsStyles={{
                  div: {
                    fontFamily: theme.fonts.regular,
                    color: theme.colors.title,
                  },
                }}
              />
            </SectionContent>
          </Section>
        </ContentScroll>
      </Content>
      {haveUnits && (
        <Footer>
          <SafeAreaView>
            <Button
              title="Ver unidades"
              onPress={() =>
                navigation.navigate('StoreUnits', {
                  data,
                })
              }
              enabled
            />
          </SafeAreaView>
        </Footer>
      )}
    </Container>
  ) : (
    <Loading />
  );
}
